import Cookies from 'js-cookie';
import { getJwtUser } from '@speareducation/util/auth';

const assetsUrl = /speareducation\.com/.test(window.location.host)
  ? 'https://assets.speareducation.com'
  : 'https://assets.speareducation.net';

const avatarsUrl = assetsUrl.replace('assets', 'avatars');

const isMobileWebview = () => {
  // if the request came from online to show the iFrame, don't set a cookie
  if (/mobile-webview=1&hide_mobile_header=1/.test(location.search)) {
    return true;
  }

  if (/mobile-webview=1/.test(location.search)) {
    Cookies.set('mobile-webview', 1);
    return true;
  }

  return Number(Cookies.get('mobile-webview')) > 0;
}

const getMobileOS = () => {
  const ua = navigator.userAgent;

  if (/android/i.test(ua)) {
    return "Android";
  } else if ((/iPad|iPhone|iPod/.test(ua)) 
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return "iOS";
  }
  return "Other";
};

const userHasAccess = () => {
  const isSpearTalkTrialMember = app.session.user?.groups()?.map(group => group.id()).includes('11');

  if (getJwtUser().isBasicUser() && !isSpearTalkTrialMember) {
    return false;
  }

  return true;
}

export { avatarsUrl, assetsUrl, getMobileOS, userHasAccess, isMobileWebview };
